/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TerminalDiagnosisEventNotification
 */
export interface TerminalDiagnosisEventNotification {
    /**
     * 
     * @type {string}
     * @memberof TerminalDiagnosisEventNotification
     */
    eventToNotify: string;
    /**
     * 
     * @type {boolean}
     * @memberof TerminalDiagnosisEventNotification
     */
    maintenanceRequired: boolean;
    /**
     * 
     * @type {string}
     * @memberof TerminalDiagnosisEventNotification
     */
    customerLanguage?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TerminalDiagnosisEventNotification
     */
    eventDetails?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TerminalDiagnosisEventNotification
     */
    timestamp?: string | null;
}

/**
 * Check if a given object implements the TerminalDiagnosisEventNotification interface.
 */
export function instanceOfTerminalDiagnosisEventNotification(value: object): value is TerminalDiagnosisEventNotification {
    if (!('eventToNotify' in value) || value['eventToNotify'] === undefined) return false;
    if (!('maintenanceRequired' in value) || value['maintenanceRequired'] === undefined) return false;
    return true;
}

export function TerminalDiagnosisEventNotificationFromJSON(json: any): TerminalDiagnosisEventNotification {
    return TerminalDiagnosisEventNotificationFromJSONTyped(json, false);
}

export function TerminalDiagnosisEventNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): TerminalDiagnosisEventNotification {
    if (json == null) {
        return json;
    }
    return {
        
        'eventToNotify': json['eventToNotify'],
        'maintenanceRequired': json['maintenanceRequired'],
        'customerLanguage': json['customerLanguage'] === undefined ? undefined : json['customerLanguage'] === null ? null : json['customerLanguage'],
        'eventDetails': json['eventDetails'] === undefined ? undefined : json['eventDetails'] === null ? null : json['eventDetails'],
        'timestamp': json['timestamp'] === undefined ? undefined : json['timestamp'] === null ? null : json['timestamp'],
    };
}

export function TerminalDiagnosisEventNotificationToJSON(json: any): TerminalDiagnosisEventNotification {
    return TerminalDiagnosisEventNotificationToJSONTyped(json, false);
}

export function TerminalDiagnosisEventNotificationToJSONTyped(value?: TerminalDiagnosisEventNotification | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'eventToNotify': value['eventToNotify'],
        'maintenanceRequired': value['maintenanceRequired'],
        'customerLanguage': value['customerLanguage'],
        'eventDetails': value['eventDetails'],
        'timestamp': value['timestamp'],
    };
}

